import { SketchArtboardNode, SketchElementNode } from './types'

export function isArtboardElement(
  element: SketchElementNode
): element is SketchArtboardNode {
  return isArtboardElementType(element.type)
}

export function isArtboardElementType(type: SketchElementNode['type']) {
  return type === 'artboard' || type === 'symbolMaster'
}

export function isGroupElement(element: SketchElementNode) {
  return isGroupElementType(element.type)
}

export function isGroupElementType(type: SketchElementNode['type']) {
  return type === 'group' || type === 'symbolInstance'
}
